import { Values } from './types';

export const INITIAL_VALUES: Values = {
  creditCardNumber: '',
  date: '',
};
